import React from 'react';

import Thumb from '../img/works/first-website.jpg';
import Home from '../img/work-details/first-website-home.jpg';
import Blog from '../img/work-details/first-website-blog.jpg';

const FirstWPTheme = {
    id: 113, permalink: "first-wp-theme", thumb: Thumb, title: "First WordPress Theme", category: "WordPress", categoryURL: "wordpress", detailImg1: Home, detailImg2: Blog, previewTxt: "", previewURL: "", sourceTxt: "GitHub", sourceURL: "https://github.com/wasek23/first-wp-theme", description: <>
        <h3>Simple Responsive First WordPress Theme.</h3>
        <p>&nbsp;</p>

        <h5>Main Featured:</h5>
        <ul>
            <li>Home, About, Contact and Blog Page</li>
            <li>Dynamic Right and Footer Sidebar</li>
            <li>Single Post</li>
            <li>Dynamic Slider</li>
        </ul>

        <h5>Technology Used:</h5>
        <ul>
            <li>WordPress, PHP, JavaScript, jQuery, HTML, CSS</li>
        </ul>
    </>
};
export default FirstWPTheme;